import RouterPath from "libs/RouterPath";
import {Route, Switch} from "react-router-dom";
import NotFound from "../../NotFound/NotFound";
import React from "react";
import AuditTask from "./AuditTask";
import AuditListAdmin from "./AuditListAdmin";
import AuditListUser from "./AuditListUser";
import AuditTaskAdmin from "./AuditTaskAdmin";
import AuditAllowedObjectList from "./AuditAllowedObjectList";


const rp = RouterPath.audit;

function Audit() {

    return (<>
            <Switch>
                <Route path={rp.AUDIT_LIST_ADMIN} component={AuditListAdmin}/>
                <Route path={rp.AUDIT_ALLOWED_OBJECT_LIST} component={AuditAllowedObjectList}/>
                <Route path={rp.AUDIT_LIST} component={AuditListUser}/>
                <Route path={rp.AUDIT_TASK_ADMIN} component={AuditTaskAdmin}/>
                <Route path={rp.AUDIT_TASK} component={AuditTask}/>
                <Route component={NotFound}/>
            </Switch>
        </>
    )
}

export default Audit;